export default __webpack_public_path__ + "static/media/educate-icon.86f567b7.svg";